var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.025,
    height: 18,
    viewBox: "0 0 18.025 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_photo_alternate_FILL0_wght400_GRAD0_opsz48",
    d: "M7.5,24A1.494,1.494,0,0,1,6,22.5V7.5A1.494,1.494,0,0,1,7.5,6H17.725V7.5H7.5v15h15V12.3H24V22.5A1.494,1.494,0,0,1,22.5,24Zm13-12.45V9.525H18.475v-1.5H20.5V6H22V8.025h2.025v1.5H22V11.55ZM9,19.95H21l-3.6-4.8-3.175,4.175-2.35-3.1ZM7.5,7.5v0Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/add_photo.4226be1d2eac7d42a4939141bab8c5f6.svg";
export { ForwardRef as ReactComponent };